import { Playground, Props } from 'docz';
import { Image } from '@madup-inc/mad-design';
import * as React from 'react';
export default {
  Playground,
  Props,
  Image,
  React
};